import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { WatchlistSettingsDialog } from '~/components/watchlist/watchlist-settings-dialog.tsx';
import { getWatchlistPageDataQueryOptions } from '~/server/watchlist/watchlist-page-data-query.ts';

export const Route = createFileRoute('/watchlists/$watchlistIndex/news/settings')({
	component: WatchlistNewsSettingsPage,
});

function WatchlistNewsSettingsPage() {
	const { watchlistIndex } = Route.useParams();
	const { data: loaderData } = useSuspenseQuery(
		getWatchlistPageDataQueryOptions({ watchlistIndex: Number(watchlistIndex) }),
	);
	const watchlist = loaderData.watchlists[loaderData.watchlistIndex];

	if (!watchlist) {
		return null;
	}

	return (
		<WatchlistSettingsDialog
			closePath={`/watchlists/${loaderData.watchlistIndex}/news`}
			watchlist={watchlist}
			watchlistIndex={loaderData.watchlistIndex}
			watchlistsLength={loaderData.watchlists.length}
		/>
	);
}
